/**
 * @fileoverview Section "Badges" — variants du composant shadcn `<Badge>`
 * + aperçu des statuts métier GNPC (à implémenter via `StatusBadge` dédié).
 */

import { Badge } from '@gnpc/ui';
import { DsPreview } from '../components/DsPreview.tsx';

export function DsSectionBadges(): JSX.Element {
  return (
    <div className="space-y-8">
      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-quipux-navy-950">Variants génériques</h3>
        <DsPreview label="Badge shadcn — variants default / secondary / destructive / outline">
          <div className="flex flex-wrap gap-2">
            <Badge>Default</Badge>
            <Badge variant="secondary">Secondary</Badge>
            <Badge variant="destructive">Destructive</Badge>
            <Badge variant="outline">Outline</Badge>
            <Badge variant="ghost">Ghost</Badge>
          </div>
        </DsPreview>
      </div>

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-quipux-navy-950">
          Statuts métier — <span className="font-normal text-muted-foreground">preview brut</span>
        </h3>
        <p className="text-xs text-muted-foreground">
          Ces badges seront encapsulés dans <code>&lt;StatusBadge kind="…"&gt;</code> (à livrer).
          En attendant, aperçu direct via les tokens <code>status-*</code>.
        </p>

        <div className="space-y-4">
          <DsPreview label="PaymentStatus">
            <div className="flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-status-initiated/15 px-2.5 py-0.5 text-xs font-medium text-status-initiated">
                <span className="size-1.5 rounded-full bg-status-initiated" />
                INITIATED
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-status-pending/15 px-2.5 py-0.5 text-xs font-medium text-status-pending">
                <span className="size-1.5 rounded-full bg-status-pending" />
                PENDING
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-status-paid/15 px-2.5 py-0.5 text-xs font-medium text-status-paid">
                <span className="size-1.5 rounded-full bg-status-paid" />
                PAID
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-status-failed/15 px-2.5 py-0.5 text-xs font-medium text-status-failed">
                <span className="size-1.5 rounded-full bg-status-failed" />
                FAILED
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-status-expired/15 px-2.5 py-0.5 text-xs font-medium text-status-expired">
                <span className="size-1.5 rounded-full bg-status-expired" />
                EXPIRED
              </span>
            </div>
          </DsPreview>

          <DsPreview label="SgiStatus (enregistrement STI)">
            <div className="flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-status-not-applicable/25 px-2.5 py-0.5 text-xs font-medium text-quipux-navy-800">
                NOT_APPLICABLE
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-status-pending/15 px-2.5 py-0.5 text-xs font-medium text-status-pending">
                PENDING
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-status-partial/15 px-2.5 py-0.5 text-xs font-medium text-status-partial">
                PARTIAL
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-status-recorded/15 px-2.5 py-0.5 text-xs font-medium text-status-recorded">
                RECORDED
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-status-failed/15 px-2.5 py-0.5 text-xs font-medium text-status-failed">
                FAILED
              </span>
            </div>
          </DsPreview>

          <DsPreview label="IntegrationStatus">
            <div className="flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-integration-up/15 px-2.5 py-0.5 text-xs font-medium text-integration-up">
                <span className="size-1.5 animate-pulse rounded-full bg-integration-up" />
                UP
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-integration-degraded/15 px-2.5 py-0.5 text-xs font-medium text-integration-degraded">
                <span className="size-1.5 rounded-full bg-integration-degraded" />
                DEGRADED
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-integration-down/15 px-2.5 py-0.5 text-xs font-medium text-integration-down">
                <span className="size-1.5 rounded-full bg-integration-down" />
                DOWN
              </span>
            </div>
          </DsPreview>
        </div>
      </div>
    </div>
  );
}
